
import { usePopupManager } from "@/hooks/usePopupManager";

// This function creates a singleton-like behavior for the popup manager
// to be used outside of React components
let showCouponPopupFn: ReturnType<typeof usePopupManager>["showCouponPopup"] | null = null;
let showNotificationPopupFn: ReturnType<typeof usePopupManager>["showNotificationPopup"] | null = null;
let showConfirmationPopupFn: ReturnType<typeof usePopupManager>["showConfirmationPopup"] | null = null;

export const registerPopupFunctions = (functions: {
  showCouponPopup: ReturnType<typeof usePopupManager>["showCouponPopup"];
  showNotificationPopup: ReturnType<typeof usePopupManager>["showNotificationPopup"];
  showConfirmationPopup: ReturnType<typeof usePopupManager>["showConfirmationPopup"];
}) => {
  showCouponPopupFn = functions.showCouponPopup;
  showNotificationPopupFn = functions.showNotificationPopup;
  showConfirmationPopupFn = functions.showConfirmationPopup;
};

// Export functions that can be called from anywhere
export const globalPopup = {
  showCouponPopup: (title?: string, message?: string, persistent = false) => {
    if (!showCouponPopupFn) {
      console.error("Popup functions are not registered yet.");
      return "";
    }
    return showCouponPopupFn(title, message, persistent);
  },
  
  showNotificationPopup: (title: string, message: string, persistent = false) => {
    if (!showNotificationPopupFn) {
      console.error("Popup functions are not registered yet.");
      return "";
    }
    return showNotificationPopupFn(title, message, persistent);
  },
  
  showConfirmationPopup: (
    title: string,
    message: string,
    onConfirm: () => void,
    onCancel?: () => void,
    persistent = true
  ) => {
    if (!showConfirmationPopupFn) {
      console.error("Popup functions are not registered yet.");
      return "";
    }
    return showConfirmationPopupFn(title, message, onConfirm, onCancel, persistent);
  }
};

// Function to register the popup manager on app start
export const initializePopupManager = () => {
  const popupManager = usePopupManager();
  registerPopupFunctions({
    showCouponPopup: popupManager.showCouponPopup,
    showNotificationPopup: popupManager.showNotificationPopup,
    showConfirmationPopup: popupManager.showConfirmationPopup,
  });
};
